export default "__VITE_ASSET__DaW$s4m6__"